<section class="py-3">
  <div class="container-fluid card">
    <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
      
      <app-main-heading [heading]="'Purchase History'"></app-main-heading>
      <div class="d-flex align-items-center flex-wrap gap-2">
        <button class="btn fw-bold filter-toggle m-1" (click)="openFilterPanel()">
          <fa-icon class="me-1 text-dark" [icon]="faSliders" size="sm"></fa-icon>
          <span class="text-dark fw-bold small">Filters</span>
          <fa-icon class="ms-1" [icon]="showFilterPanel ? faAngleDown : faAngleUp" size="sm"></fa-icon>
        </button>
        <button class="btn app-btn-primary m-1" [routerLink]="'/new-product'">
          Add Purchase
        </button>
      </div>
    </div>
    @if (showFilterPanel) {
    <div class="card filter-card p-3 p-md-4 rounded-4 shadow-sm mb-3">
      <div class="row g-2 justify-content-start align-items-end">
        <div class="col-12 col-sm-6 col-md-3">
          <label for="tyreSizeInput" class="filter-label">Tyre Size</label>
          <input id="tyreSizeInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Size"
            [(ngModel)]="filtersForm.tyreSize" (ngModelChange)="onTextInputChange()" />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="brandInput" class="filter-label">Brand</label>
          <input id="brandInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Brand"
            [(ngModel)]="filtersForm.tyreMake" (ngModelChange)="onTextInputChange()" />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="patternInput" class="filter-label">Pattern</label>
          <input id="patternInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Model"
            [(ngModel)]="filtersForm.tyreModel" (ngModelChange)="onTextInputChange()" />
        </div>
        <div class="col-12 col-sm-6 col-md-3">
          <label for="purchaseTypeSelect" class="filter-label">Purchase Type</label>
          <ng-select labelForId="purchaseTypeSelect" [items]="purchaseTypes" bindLabel="label" bindValue="value" [multiple]="false"
            [clearable]="true" placeholder="Purchase type..." class="ng-select-bootstrap"
            (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.stockInType" appendTo="body">
          </ng-select>
        </div>
        @if(isBranchVisible) {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="branchSelect" class="filter-label">Branch</label>
          <ng-select labelForId="branchSelect" [items]="companyData" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="true" [searchable]="true" placeholder="Select Branch..." [trackByFn]="trackById"
            (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.branch" class="ng-select-bootstrap"
            appendTo="body">
          </ng-select>
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3 d-flex align-items-center mb-2">
          <input id="pendingInvoicesCheckbox" type="checkbox" class="checkbox m-0" [checked]="filterPendingInvoice" (change)="invoiceFilterList($event)" />
          <label for="pendingInvoicesCheckbox" class="ms-2 mb-0" style="white-space: nowrap">Pending invoices</label>
        </div>
      </div>
    </div>
    }
    <div class="card app-table-thick-border shadow-none mb-2">
      <div class="table-responsive app-scrollbar" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
        <table class="table app-table-rounded align-middle m-0 w-100">
          <thead>
            <tr class="app-table-header">
              <th>DATE/TIME</th>
              <th class="text-center">BRANCH</th>
              <th class="text-center">TYPE</th>
              <th>USER</th>
              <th>SKU DESCRIPTION</th>
              <th>QTY</th>
              <th>PURCHASE PRICE</th>
              <th>INVOICE</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          @if (company2.length >= 1) {
          <tbody class="app-td-text">
            @if (company2.length > 0) {
            @for (name of company2; track name; let modelIndex = $index) {
            @if (name.stock && name.stock.length > 0) {
            @for (
            tyreDetails of name.stock;
            track tyreDetails;
            let i = $index
            ) {
            <tr class="table-row">
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="td-text-one text-nowrap bottom-border">
                <div class="d-flex flex-column gap-1">
                  <span class="text-dark">{{ name.formattedDateStr }}</span>
                  <span class="text-dark">{{ name.formattedTimeStr }}</span>
                </div>
              </td>
              }
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="td-text-two text-dark text-center bottom-border">
                {{ name.company?.name }}
              </td>
              }
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="bottom-border">
                <div class="d-flex flex-column align-items-center text-center">
                  <span class="badge type-badge mb-1" [ngClass]="name.badgeClass">
                    {{ name.stockInType | capitalSpace }}
                  </span>
                  @if(name?.dealer?.name) {
                    <span class="td-text-two text-muted">
                      {{ name?.dealer?.name }}
                    </span>
                  }
                  @if(name?.fromBranch?.name) {
                  <span class="td-text-two text-muted">
                    {{ name?.fromBranch?.name }}
                  </span>
                  }
                </div>
              </td>
              }
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="td-text-one bottom-border">
                {{name?.createdBy?.name }}
              </td>
              }
              <td [class.bottom-border]="i === name.stock.length - 1">
                <span class="td-text-three">
                  {{ tyreDetails.tyreSize }} {{ tyreDetails.tyreMake }}
                  {{ tyreDetails.tyreModel }}
                </span>
              </td>
              <td class="td-text-one" [class.bottom-border]="i === name.stock.length - 1">
                @if (tyreDetails.finalQuantity !== null) {
                {{ tyreDetails.finalQuantity }}
                } @else {
                -
                }
              </td>
              <td class="td-text-one" [class.bottom-border]="i === name.stock.length - 1">
                @if (tyreDetails.finalUnitPrice !== null) {
                ₹{{ tyreDetails.finalUnitPrice | number }}
                } @else {
                -
                }
              </td>
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="td-text-two bottom-border"
                (click)="viewVoucher(name, pdfModel)" [ngClass]="{
                            'text-primary cursor-pointer': name.invoice
                          }">
                <div class="d-flex flex-column align-items-start gap-1">
                  <span class="text-break">{{ name.replacedInvoiceNumber || name.invoiceNumber || "-" }}</span>
                  
                  @if (name.isPendingInvoice) {
                  <div class="d-flex align-items-center gap-2" (click)="$event.stopPropagation()">
                    <span class="small text-danger">Pending</span>
                  </div>
                  }
                </div>
              </td>
              }
              @if (i === 0) {
              <td [attr.rowspan]="name.stock.length" class="bottom-border text-center align-middle">
                <div class="d-flex flex-column align-items-center gap-2">
                  @if (name.showPrimaryButton) {
                  <span [ngbTooltip]="name.buttonTooltip" triggers="hover" container="body" placement="left">
                    <button class="btn btn-sm app-btn-primary" [disabled]="name.disablePrimaryButton" (click)="editPurchase(name)">
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </button>
                  </span>
                  }
                  @if (name.fullReason) {
                  <span [ngbTooltip]="'Transaction is edited click to view full reason'" triggers="hover" container="body" placement="left">
                    <button class="btn btn-sm btn-reason-log" (click)="openReasonModal(name)">
                      <fa-icon [icon]="faInfoCircle"></fa-icon>
                    </button>
                  </span>
                  }
                </div>
              </td>
              }
            </tr>
            }
            }
            }
            }
          </tbody>
          }

          @if (loader) {
            <tbody>
              <tr>
                <td colspan="9">
                  <div class="custom-col-width-100 d-flex justify-content-center py-5">
                    <app-loader [loadingIcon]="loader"></app-loader>
                  </div>
                </td>
              </tr>
            </tbody>
          }

          @if (!loader && company2.length === 0) {
            <tbody>
              <tr>
                <td colspan="9">
                  <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                    No Records Found!
                  </div>
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    </div>
  </div>
</section>

<ng-template #pdfModel let-modal>
  <div class="app-pdf-model">
    <div class="modal-header">
      <h3 class="m-0" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 80%;">{{ selectedVocher.name }}</h3>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-0 text-center">
      @if (isImageVoucher) {
        <img [src]="selectedVocher.rawUrl" class="img-fluid" style="max-height: calc(85vh - 50px); object-fit: contain; width: 100%; height: 100%;" alt="Invoice" />
      } @else {
        <iframe [src]="selectedVocher.url" class="pdf-iframe" title="PDF Document Viewer"> </iframe>
      }
    </div>
  </div>
</ng-template>